export default function benefitByKey(benefits = [], key) {
  return benefits.map((benefit) => {
    if (benefit.display_name === key) {
      return benefit.text;
    }
  });
}
